module.exports = __webpack_public_path__ + "img/Toggle-On.53bfe7d1.svg";